import { isAndroid } from '@/utils';
import { INPUT_NODE_NAME, TEXTAREA_NODE_NAME, PAGE_HEIGHT_OFFSET } from '@/utils/constant';

// 处理键盘弹出问题
export default function inputHandler() {
  let focusIn = false;
  window.addEventListener('focusin', (e) => {
    const { target } = e;
    const { nodeName } = target;
    if (nodeName === INPUT_NODE_NAME || nodeName === TEXTAREA_NODE_NAME) {
      focusIn = true;
      const windowHeight = window.innerHeight - 200;
      const clientTop = target.getBoundingClientRect().top;
      const top = Math.floor(clientTop - 30);
      if (isAndroid() && clientTop > windowHeight) {
        const $pageContent = document.querySelector('.page-content');
        if ($pageContent) {
          $pageContent.scrollTo(0, top);
          return;
        }
        window.scrollTo(0, top);
      }
    }
  });
  window.addEventListener('focusout', () => {
    const stopScrollTop = document.querySelector('.stop-scroll-top');
    const containerHeight = stopScrollTop.offsetHeight;
    const bodyHeight = document.body.clientHeight;
    if (focusIn && (containerHeight < (bodyHeight + PAGE_HEIGHT_OFFSET))) {
      window.scrollTo(0, 0);
    }
  });
}
